module.exports = __webpack_public_path__ + "static/media/comp_banner_bg.666a31cf.svg";